<template>
  <div>
    <section>
      <div>
        <div class="form-inline flex-row">
          <model-select
            :options="verifiedOptions"
            v-model="editVerified"
            placeholder="Verified"
          ></model-select>
        </div>
        <div class="form-inline flex-row">
          <model-select
            :options="metroOptions"
            v-model="editMetro"
            placeholder="Metro"
          ></model-select>
        </div>
        <div class="form-inline flex-row">
          <model-select
            :options="skillOptions"
            v-model="editSkill"
            placeholder="Skill"
          ></model-select>
        </div>
        <div class="form-inline flex-row">
          <model-select
            :options="certificationOptions"
            v-model="editCertification"
            placeholder="Certification"
          ></model-select>
        </div>
        <div class="form-inline flex-row">
          <model-select
            :options="levelOptions"
            v-model="editLevel"
            placeholder="Level"
          ></model-select>
        </div>
        <div class="form-inline flex-row">
          <model-select
            :options="activeOptions"
            v-model="editActive"
            placeholder="Active"
          ></model-select>
        </div>
        <div class="at-worktype-wrapper">
          <div
            class="at-worktype-item"
            v-for="(item, index) in editWorkTypes"
            :key="index"
          >
            <input v-model="item.value" type="checkbox" />{{ item.text }}
          </div>
        </div>
        <div class="form-inline flex-row">
          <div style="text-align: left">Not:</div>
        </div>
        <div class="at-worktype-wrapper">
          <div
            class="at-worktype-item"
            v-for="(item, index) in editNotWorkTypes"
            :key="index"
          >
            <input v-model="item.value" type="checkbox" />{{ item.text }}
          </div>
        </div>

        <div class="form-inline flex-row">
          <button class="submit primary" @click="onApply">Apply Filters</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  props: [
    "metroOptions",
    "skillOptions",
    "certificationOptions",
    "levelOptions",
    "metroFilter",
    "certificationFilter",
    "skillFilter",
    "levelFilter",
    "serachFilter",
    "workTypes",
    "notWorkTypes",
    "verified",
    "isActive",
  ],
  components: {
    ModelSelect,
  },
  // Part time,Full time,Remotely during work hours,Off hours/weekends,Ad hoc field IT visits
  data() {
    return {
      show: false,
      editMetro: null,
      editCertification: null,
      editSkill: null,
      editLevel: null,
      editWorkTypePT: null,
      editWorkTypeFT: null,
      editWorkTypeRe: null,
      editWorkTypeOff: null,
      editWorkTypeAd: null,
      editSearch: null,
      editWorkTypes: [],
      editNotWorkTypes: [],
      editVerified: null,
      verifiedOptions: [
        { text: "ALL(Verified)", value: null },
        { text: "true", value: true },
        { text: "false", value: false },
      ],
      editActive: null,
      activeOptions: [
        { text: "ALL(Active)", value: null },
        { text: "active", value: true },
        { text: "inactive", value: false },
      ],
    };
  },
  beforeMount() {
    this.editMetro = this.metroFilter;
    this.editCertification = this.certificationFilter;
    this.editSkill = this.skillFilter;
    this.editLevel = this.levelFilter;
    this.editSearch = this.serachFilter;
    this.editVerified = this.verified;
    this.editActive = this.isActive;
    this.editWorkTypes = JSON.parse(JSON.stringify(this.workTypes));
    this.editNotWorkTypes = JSON.parse(JSON.stringify(this.notWorkTypes));
  },
  methods: {
    toggleShow: function () {
      this.show = !this.show;
    },
    prevent: function (e) {
      e.preventDefault();
    },
    onApply: function () {
      const data = {
        metro: this.editMetro,
        certification: this.editCertification,
        skill: this.editSkill,
        level: this.editLevel,
        workTypes: this.editWorkTypes,
        notWorkTypes: this.editNotWorkTypes,
        search: this.editSearch,
        verified: this.editVerified,
        isActive: this.editActive,
      };
      this.$emit("buttonClick", data);
      this.show = false;
    },
  },
};
</script>

<style scoped>
.at-wrapper {
  display: flex;
  align-items: center;
  font-size: var(--font-size-2l);
  padding: 0 10px;
  position: relative;
}
.at-button {
  flex-grow: 1;
  text-align: left;
  height: 100%;
  line-height: 65px;
  cursor: pointer;
}
.at-options {
  border-radius: 4px;
  border: 1px solid #eee;
  width: 320px !important;
  position: absolute;
  top: 65px !important;
  right: 0 !important;
  background: #fff;
  padding: 16px 24px;
  max-height: 400px;
  overflow-y: scroll;
}
.at-options > :not(:first-child) {
  margin-top: 16px;
}
.at-worktype-wrapper {
  display: flex;
  font-size: 16px;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin: 0 10px 10px;
}
.at-worktype-item {
  display: flex;
  align-items: center;
}
.at-worktype-item > div {
  white-space: nowrap;
}
</style>
